import React from "react";
import { Switch, Route } from "react-router-dom";
import { NotFound } from "./NotFound";
import PrivateRoute from "./Auth/PrivateRoute";

import { LayoutContainer } from "../pages/Shared/LayoutContainer";

import { LoginContainer } from "../pages/Account/LoginContainer";
import { ChefLoginContainer } from "../pages/Account/ChefLoginContainer";
import { HomeContainer } from "../pages/Home/HomeContainer";
import { EventList } from "../pages/Event/List";
import { SupplierList } from "../pages/Supplier/List";
import { EventDetail } from "../pages/Event/Detail";
import { SupplierEventList } from "../pages/Event/SupplierEventList";
import { PersonnelList } from "../pages/Personnel/List";
import { EventPersonnelRegister } from "../pages/Event/EventPersonnelRegister";
import { PayoffList } from "../pages/Payoff/List";
import { BlacklistList } from "../pages/Blacklist/List";
import { ChefPersonnelAssign } from "../pages/Event/ChefPersonnelAssign";
import { LocationList } from "../pages/Location/List";
import { EventPlaceList } from "../pages/EventPlace/List";

export const RouterConfig = () => {
  return (
    <div>
      <Switch>
        {/* List all public routes here */}
        
        <Route path="/login">
          <LoginContainer />
        </Route>
        
        <Route path="/chef-login">
          <ChefLoginContainer />
        </Route>

        <PrivateRoute path="/chef-personnel-assign">
          <ChefPersonnelAssign />
        </PrivateRoute>

        <PrivateRoute path="/supplier-events">
          <LayoutContainer Right={<SupplierEventList/>} />
        </PrivateRoute>

        <PrivateRoute path="/personnels">
          <LayoutContainer Right={<PersonnelList/>} />
        </PrivateRoute>

        <PrivateRoute path="/event-locations">
          <LayoutContainer Right={<LocationList/>} />
        </PrivateRoute>

        <PrivateRoute path="/event-places">
          <LayoutContainer Right={<EventPlaceList/>} />
        </PrivateRoute>

        <PrivateRoute path="/events">
          <LayoutContainer Right={<EventList/>} />
        </PrivateRoute>

        <PrivateRoute path="/event/:uniqueKey">
          <LayoutContainer Right={<EventDetail/>} />
        </PrivateRoute>

        <PrivateRoute path="/event-personnel-register/:uniqueKey">
          <EventPersonnelRegister />
        </PrivateRoute>

        <PrivateRoute path="/suppliers">
          <LayoutContainer Right={<SupplierList/>} />
        </PrivateRoute>

        <PrivateRoute path="/payoff">
          <LayoutContainer Right={<PayoffList/>} />
        </PrivateRoute>

        <PrivateRoute path="/blacklist">
          <LayoutContainer Right={<BlacklistList/>} />
        </PrivateRoute>

        <PrivateRoute path="/">
          <LayoutContainer Right={<HomeContainer/>} />
        </PrivateRoute>

       
       

        {/* List all private/auth routes here */}
        {/* <PrivateRoute path={AUTH_PAGE1}>
          <AuthorizedPage1 />
        </PrivateRoute> */}
        {/* Do not hesitate to play around by moving some routes from public to private and vice-versa */}
        {/* <PrivateRoute path={DASHBOARD}>
          <Dashboard />
        </PrivateRoute> */}

        {/* List a generic 404-Not Found route here */}
        <Route path="*">
          <NotFound />
        </Route>
      </Switch>
    </div>
  );
};
